import React, { useState } from 'react';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';
import SuccessModal from 'src/components/Modals/SuccessModal';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Box, Button, Grid, Modal, Snackbar } from '@mui/material';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ConfirmForm from '../Appointments/ConfirmForm';

const initialValue = {
  name: '',
  duration: '',
  price: '',
};

const AddSubscription = () => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [formData, setFormData] = useState(initialValue);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [services, setServices] = useState(null);
  const [branch, setBranch] = useState(null);

  const { createSubscription } = useMain();

  const handleSubmit = async () => {
   
    const { name, duration, price } = formData;
    if (name.trim() === '') return setErrorMessage('Name is Required');
    if (duration === '') return setErrorMessage('Duration is Requires');
    if (price === '') return setErrorMessage('Price is Requires');

    setShowLoader(true);

    const res = await createSubscription(JSON.stringify({ ...formData }));
    if (res?.statusCode === 200) {
      setSuccessMessage('Subscription Successfully Created');
      setTimeout(() => {
        setSuccessMessage('');
      }, 7000);
      setErrorMessage('');
      setShowLoader(false);
    } else {
      setErrorMessage(res?.message);
      setTimeout(() => {
        setErrorMessage('');
      }, 7000);
      setShowLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <PageContainer title="Create Subscription" description="this is add Subscription">
      <DashboardCard title="Create Subscription">
        <Snackbar
          open={errorMessage == '' ? false : true}
          autoHideDuration={6000}
          onClose={() => {
            setErrorMessage('');
          }}
          severity="error"
          message={errorMessage}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Client Name'}
                name={'name'}
                value={formData?.name}
                handleChange={handleChange}
                type={'text'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Duration'}
                name={'duration'}
                value={formData?.duration}
                handleChange={handleChange}
                type={'text'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                title={'Price'}
                name={'price'}
                value={formData?.price}
                handleChange={handleChange}
                type={'number'}
              />
            </Grid>
          </Grid>
        </Box>

        {showLoader && <ShowLoader value={showLoader} />}
        {successMessage != '' && <ShowSuccess message={successMessage} />}

        <div style={{ width: '200px', margin: '3rem auto' }}>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            target="_blank"
            sx={{
              background: '#6174DD',
            }}
            // onClick={() => setOpenConfirm(true)}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddSubscription;
